import { axiosInstance } from "api/axios-config/axios-config";
import { Pagination } from "api/models/response/pagination";

import {
  AddCustomer,
  GetCustomer,
  UpdateCustomer,
} from "api/models/request/customer/customer";
import { DEFAULT_CATALOG_SLICE_SIZE } from "commons/constants";
import { mapToDistinctOptionItems } from "commons/ultilities/option-item/option-item-ultil";
import { ICatalogue } from "mobx-stores/_models/base";
import {
  ICustomerDetailProperties,
  ICustomerProperties,
} from "mobx-stores/_models/customers/customer";
import { IDeliveryAddressProperties } from "mobx-stores/_models/customers/delivery-address";
import { BaseBussiness } from "../base";

class CustomerBusiness extends BaseBussiness<
  ICustomerProperties,
  AddCustomer,
  UpdateCustomer,
  ICustomerDetailProperties
> {
  url = "";
  constructor(url: string) {
    super(url);
    this.url = url;
  }
  public getCustomerType = async () => {
    try {
      var res = await axiosInstance.get<Pagination<ICatalogue>>(
        this.url + "/customer-type",
      );
      return res.data;
    } catch (error) {
      console.error("Fail getCustomerType", error);
      return Promise.reject(error);
    }
  };

  public searchCustomerAsOptionItems = async (keyword: string) => {
    const customers = await customerBusiness.getLists<GetCustomer>({
      filter: keyword,
      maxResultCount: DEFAULT_CATALOG_SLICE_SIZE,
      skipCount: 0,
      sorting: "",
      isDisabled: false,
    });
    return mapToDistinctOptionItems(
      customers.items,
      (x) => x.id,
      (x) => x.dealingName,
    );
  };

  public searchAllCustomers = async (keyword: string) => {
    const customers = await customerBusiness.getLists<GetCustomer>({
      filter: keyword,
      maxResultCount: DEFAULT_CATALOG_SLICE_SIZE,
      skipCount: 0,
      sorting: "",
      isDisabled: false,
    });

    return customers;
  };

  public getDeliveryAddressByCustomerAsOptionItems = async (
    customerId: string,
  ) => {
    const res = await axiosInstance.get<Pagination<IDeliveryAddressProperties>>(
      `${this.url}/delivery-address-by-customer/${customerId}`,
    );
    return mapToDistinctOptionItems(
      res?.data?.items,
      (x) => x.id,
      (x) => x.address,
    );
  };
}

export const customerBusiness = new CustomerBusiness("/api/app/customer");
